import { CircleLogo } from "./CircleLogo";
import { ProgressBar } from "./ProgressBar";

interface HeaderProps {
  progress?: {
    currentStep: number;
    totalSteps: number;
  };
}

export const Header = ({ progress }: HeaderProps) => (
  <div className="mb-8 flex items-center justify-between">
    <CircleLogo className="text-primary-900 h-8" />
    {progress && <ProgressBar {...progress} />}
  </div>
);
